module.exports = __webpack_public_path__ + "static/moniele-5e46994cd729f2949aa1fc00adfe0d03.png";